const QueryParam = Object.freeze({
  FORM_DATA_ID: "form_data_id",
  MODULE_ID: "module_id",
  ACTIVE_TAB: "active_tab",
  IS_OPEN: "open"
});

export {QueryParam}




// WEBPACK FOOTER //
// ./src/enums/queryParam.js